import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20golden%20amber%20light%20rays%20streaming%20through%20soft%20atmospheric%20haze%2C%20subtle%20film%20grain%20texture%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20minimalist%20streaming%20platform%20aesthetic%2C%20elegant%20and%20sophisticated%20atmosphere%2C%20ample%20soft%20background%20space%2C%20dreamy%20ethereal%20quality&width=1600&height=900&seq=hero-bg-7788&orientation=landscape"
          alt="7788电影网主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/30"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium mb-5 md:mb-6 tracking-wide whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4 md:mb-5">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-background-50/80 font-heading mb-5 md:mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7 md:mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7 md:mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-background-50">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 md:gap-4">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(heroData.primaryCta.href);
                }}
                className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(heroData.secondaryCta.href);
                }}
                className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-md border border-background-50/40 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {heroData.secondaryCta.label}
                <i className="ri-medal-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20featuring%20warm%20golden%20and%20amber%20color%20palette%20with%20soft%20atmospheric%20lighting%2C%20abstract%20film%20and%20streaming%20visual%20elements%2C%20modern%20minimalist%20design%20aesthetic%2C%20sophisticated%20and%20artistic%20mood%2C%20subtle%20bokeh%20and%20light%20leak%20effects%2C%20premium%20visual%20quality%2C%20warm%20cream%20and%20coral%20highlights&width=1200&height=800&seq=hero-visual-7788&orientation=landscape"
                alt="7788电影网 - 高清追剧不缓冲"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}